import { AmplitudeEvents } from '@utils/trackingEvents';

export default defineNuxtRouteMiddleware(({ meta, name, path }) => {
    if (!import.meta.client || meta.skipAnalyticsMiddleware) return;

    const computedName = meta.customPageTrackName || name?.toString();
    if (!computedName) return;

    const { $analyticsTrack } = useNuxtApp();

    // We intentionally don't await promise returned by $analyticsTrack because
    // it delays navigation by noticeable amount of time what leads to worse UX

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $analyticsTrack(AmplitudeEvents.attendeePageViewed, {
        page: `attendee-${computedName}`,
        path,
    });
});
